import { ConvexReactClient } from 'convex/react'

/**
 * The app's single Convex client.
 *
 * `ConvexProviderWithClerk` attaches the Clerk token to this instance, so
 * non-React callers (Zustand stores) can import it and issue authenticated
 * queries/mutations without threading a client through React context.
 *
 * Metro resolves `convex-client.native.ts` over this file, which is why the
 * only thing here is construction: `import.meta.env` is Vite syntax that a
 * React Native bundler cannot parse at all.
 */
export const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string)

// Re-exported so every caller keeps importing the gate from `convex-client`,
// on both platforms, exactly as before.
export { setConvexAuthenticated, whenConvexReady } from '@/lib/convex-ready'
